import { Box, Grid, Typography, useTheme } from "@mui/material";
import CountUp from "react-countup";
import { tokens } from "../../../../theme";

const KpiCard = ({ title, value, color, isCurrency = true }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      p={3}
      backgroundColor={colors.primary[400]}
      borderRadius="12px"
      sx={{
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
        transition: "transform 0.2s ease-in-out",
        ":hover": { transform: "translateY(-3px)" },
      }}
    >
      <Typography variant="h6" color={colors.grey[300]} mb={1}>
        {title}
      </Typography>
      <Typography variant="h3" fontWeight="bold" sx={{ color }}>
        <CountUp
          end={value}
          duration={1.2}
          separator=","
          decimals={isCurrency ? 2 : 0}
          prefix={isCurrency ? "$" : ""}
        />
      </Typography>
    </Box>
  );
};

const SalesKpiCards = ({ totals }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title="Total Facturado" value={totals.facturado} color={colors.blueAccent[400]} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title="Total Cobrado" value={totals.cobrado} color={colors.greenAccent[400]} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title="Total Pendiente" value={totals.pendiente} color={colors.redAccent[400]} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          title="Total Paquetes"
          value={totals.paquetes}
          color={colors.grey[100]}
          isCurrency={false}
        />
      </Grid>
    </Grid>
  );
};

export default SalesKpiCards;
